import { useMemo } from "react";
import type { TeamData } from "../Cteamcard";

interface UseCarouselVendorsParams {
  teams: TeamData[];
  getUniqueVendors: (models: TeamData["models"]) => string[];
}

export function useCarouselVendors({
  teams,
  getUniqueVendors,
}: UseCarouselVendorsParams): Map<string, string[]> {
  return useMemo(() => {
    const vendorsByTeamId = new Map<string, string[]>();
    teams.forEach((team) => {
      vendorsByTeamId.set(team.id, getUniqueVendors(team.models ?? []));
    });
    return vendorsByTeamId;
  }, [teams, getUniqueVendors]);
}
